module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-stone-path-background-remnants.95b58161.png";